<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <Html :lang="head.htmlAttrs?.lang">
    <Head>
      <template v-for="link in head.link" :key="link.id">
        <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
      </template>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :content="meta.content" :property="meta.property" />
      </template>

      <Meta name="viewport" content="viewport-fit=cover, width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
    </Head>
  </Html>

  <NuxtPwaManifest />

  <v-app>
    <v-layout class="background-image" :style="backgroundImage">
      <v-main scrollable name="main-content">
        <slot />

        <snackbar-toaster :snackbars="snackbars" />
      </v-main>

      <v-dialog :model-value="cookiePreferences.length === 0" persistent width="600">
        <cookie-message @accept="(preferences) => setCookiePreferences(preferences)" />
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script setup lang="ts">
const mainStore = useMainStore()
const { snackbars } = storeToRefs(mainStore)

const { cookiePreferences } = useUserPreferences()
const head = useLocaleHead()

useThemeWatcher()

const setCookiePreferences = (preferences: Array<string>) => {
  cookiePreferences.value = preferences
}

const amountOfBackgrounds = 7
const bg = Math.floor(Math.random() * amountOfBackgrounds) + 1

const backgroundImage = {
  backgroundImage: `url(/sam/backgrounds/${bg}.jpg)`,
}
</script>

<style scoped>
.background-image {
  background-size: cover;
  background-position: center;
}

.login-background {
  min-height: 300px;
  background-repeat: no-repeat;
}
</style>
